export const formatDate = (datTimeString) => {
  return datTimeString?.split('T')[0];
};

export const convertMessageToHtmlIfNecessary = (massage) => {
  // Gérer les cas où message est undefined, null ou vide
  if (!massage || typeof massage !== 'string') {
    return '';
  }
  
  // message is html if it starts with < and ends  with >
  const messageIsHtml = massage.startsWith('<') && massage.endsWith('>');
  // unless message is html convert it to <p> </p> and replace end of lines with <br/>
  if (!messageIsHtml) {
    return `<p>${massage.replace(/\n/g, '<br/>')}</p>`;
  } else {
    return massage;
  }
};
